const routeMatches = (route: string) => {
  const currentPath = window.location.pathname;
  const currentSearch = window.location.search;
  const currentHash = window.location.hash;
  const [pathWithSearch, hash] = route.split('#');
  const [routePath, routeQuery] = pathWithSearch.split('?');

  if (hash) {
    return routePath === currentPath && currentHash === `#${hash}`;
  }

  if (routeQuery) {
    return routePath === currentPath && currentSearch.includes(routeQuery);
  }

  if (routePath.includes(':')) {
    const routeSegments = routePath.split('/').filter(Boolean);
    const currentSegments = currentPath.split('/').filter(Boolean);

    return (
      routeSegments.length === currentSegments.length &&
      routeSegments.every(
        (segment, index) =>
          segment.startsWith(':') || segment === currentSegments[index]
      )
    );
  }

  if (routePath === '/') {
    return currentPath === routePath;
  }

  if (currentHash && routePath === currentPath) {
    return false;
  }

  return currentPath === routePath || currentPath.startsWith(`${routePath}/`);
};

export const isActiveRoute = (route: string, activeRoutes: string[] = []) => {
  return [route, ...activeRoutes].some(routeMatches);
};
